import React from 'react';
import css from "./SecTwo.module.scss";
import {Link} from "react-router-dom";
import {designTypes} from "../../../../Utils/services/design/designTypes";
import {useTranslation} from "react-i18next";

const SecTwo = () => {

    const {t} = useTranslation();

    return (
        <section className={css.two}>
            <div className={css.main}>
                <div className={css.text}>
                    <p>
                        {t("servDesignText")} <span>{t("servDesignSpan")}</span> {t("servDesignTextCont")}
                    </p>
                </div>
                <div className={css.types}>
                    {
                        designTypes.map(({id, type, arrow})=>{
                            return(
                                <Link
                                    key={id}
                                    className={css.type}
                                >
                                    <div className={css.arrow}>
                                        {arrow}
                                    </div>
                                    <p>
                                        {t(type)}
                                    </p>
                                </Link>
                            )
                        })
                    }
                </div>
            </div>
        </section>
    );
};

export default SecTwo;